"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectDiscoveryPeerSource = void 0;
class ObjectDiscoveryPeerSource {
    constructor(mesh, object, linkupServers, replyEndpoint, parseEndpoint, timeout = 3) {
        this.mesh = mesh;
        this.object = object;
        this.parseEndpoint = parseEndpoint;
        this.linkupServers = linkupServers;
        this.replyEndpoint = replyEndpoint;
        this.timeoutMillis = timeout * 1000;
        this.hash = object.hash();
    }
    async getPeers(count) {
        let unique = new Set();
        let found = [];
        let now = Date.now();
        let limit = now + this.timeoutMillis;
        if (this.replyStream === undefined) {
            this.replyStream = this.tryObjectDiscovery(count);
            ;
        }
        else {
            let reply = this.replyStream.nextIfAvailable();
            while (reply !== undefined && found.length < count) {
                const peerInfo = await this.parseEndpoint(reply.source);
                if (peerInfo !== undefined && !unique.has(peerInfo.endpoint)) {
                    found.push(peerInfo);
                    unique.add(peerInfo.endpoint);
                }
                reply = this.replyStream.nextIfAvailable();
            }
            if (found.length < count) {
                this.retryObjectDiscovery(count);
            }
        }
        while (found.length < count && now < limit) {
            now = Date.now();
            try {
                const reply = await this.replyStream.next(limit - now);
                const peerInfo = await this.parseEndpoint(reply.source);
                if (peerInfo !== undefined && !unique.has(peerInfo.endpoint)) {
                    found.push(peerInfo);
                    unique.add(peerInfo.endpoint);
                }
            }
            catch (reason) {
                if (reason === 'timeout') {
                    break;
                }
                else if (reason === 'end') {
                    this.replyStream = this.tryObjectDiscovery(count - found.length);
                    break;
                }
                else {
                    console.log(reason);
                    // something odd happened TODO: log this
                    break;
                }
            }
        }
        return found;
    }
    getPeerForEndpoint(endpoint) {
        return this.parseEndpoint(endpoint);
    }
    tryObjectDiscovery(count) {
        return this.mesh.findObjectByHash(this.hash, this.linkupServers, this.replyEndpoint, count);
    }
    retryObjectDiscovery(count) {
        this.mesh.findObjectByHashRetry(this.hash, this.linkupServers, this.replyEndpoint, count);
    }
}
exports.ObjectDiscoveryPeerSource = ObjectDiscoveryPeerSource;
//# sourceMappingURL=ObjectDiscoveryPeerSource.js.map